import { useCallback } from "react";
import useStore from "../store";
import { useShallow } from "zustand/react/shallow";
import {
  useEventEmitterContext,
  EventEmitterType,
  AgentSaveType,
} from "../../../context/event-emitter.js";

const useFlowData = () => {
  const { nodes, edges, _onNodesChange, _onEdgesChange, _onConnect } = useStore(
    useShallow((state) => ({
      nodes: state.nodes,
      edges: state.edges,
      _onNodesChange: state.onNodesChange,
      _onEdgesChange: state.onEdgesChange,
      _onConnect: state.onConnect,
    }))
  );
  const { eventEmitter } = useEventEmitterContext();

  const handleAutoSave = useCallback(() => {
    eventEmitter?.emit({
      type: EventEmitterType.AgentSave,
      payload: AgentSaveType.WorkFlow,
    });
  }, [eventEmitter]);

  const onNodesChange = useCallback(
    (changes) => {
      console.log("onNodesChange", changes);
      if (
        changes.some((obj) => obj.type === "remove" && obj.id === "start_node")
      ) {
        return;
      }
      _onNodesChange(changes);

      const isDragging = changes.some(
        (obj) => obj.type === "position" && obj.dragging
      );
      const isSelected = changes.some((obj) => obj.type === "select");
      const isDimensions = changes.some((obj) => obj.type === "dimensions");

      if (!isDragging && !isSelected && !isDimensions) {
        handleAutoSave();
      }
    },
    [_onNodesChange, handleAutoSave]
  );

  const onEdgesChange = useCallback(
    (changes) => {
      console.log("onEdgesChange", changes);
      _onEdgesChange(changes);

      const isSelected = changes.some((obj) => obj.type === "select");

      if (!isSelected) {
        handleAutoSave();
      }
    },
    [_onEdgesChange, handleAutoSave]
  );

  const onConnect = useCallback(
    (connection) => {
      console.log("onConnect", connection);
      _onConnect({
        ...connection,
      });

      handleAutoSave();
    },
    [_onConnect, handleAutoSave]
  );

  return { nodes, edges, onNodesChange, onEdgesChange, onConnect };
};

export default useFlowData;
